var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"ps-index"},[_c('el-header',{staticClass:"app-header editor-header"},[_c('app-title',{attrs:{"name":"智能抠图","homeUrl":"/template/public","isHomePage":false},on:{"goHome":_vm.goHome}})],1),_c('el-main',[_c('iframe',{attrs:{"src":_vm.psUrl,"id":"psIframe"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }